import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { useFormik } from 'formik'
import * as yup from 'yup'

import { resetPassword } from 'features/auth/actions'
import { selectAuthCommunication } from 'features/auth/selectors'

const validationSchema = yup.object().shape({
  email: yup.string().required('required').email('enterValidEmail'),
})

type UseForgotPasswordProps = {
  onSuccess?: () => void
}

export const useForgotPassword = (props?: UseForgotPasswordProps) => {
  const dispatch = useDispatch()
  const { isLoading, isSuccess, error } = useSelector(selectAuthCommunication, shallowEqual).resetPassword

  const formik = useFormik({
    initialValues: {
      email: '',
    },
    validationSchema,
    onSubmit: values => {
      dispatch(
        resetPassword({
          email: values.email,
          callback: props?.onSuccess,
        }),
      )
    },
  })

  return {
    formik,
    isSuccess,
    isLoading,
    error,
  }
}
